import React from 'react'
import { TablaCiclosGPSSolicitud } from './TablaCiclosGPSSolicitud'

export const SolicitudesCiclosGPS = ({ idMina }) => {

    return (
        <TablaCiclosGPSSolicitud id_area_operacion={idMina}/>
    )
}
